export const DEV_CLIENT_URL = 'https://moncashback.floabank.fr/';
export const STAGING_CLIENT_URL = 'https://moncashback.floabank.fr/';
export const PROD_CLIENT_URL = 'https://moncashback.floabank.fr/';



// WEBPACK FOOTER //
// ./src/constants/sso.js